
<!-- Submit Quotation Popup -->
<div class="common-popup-container add-user-account-popup doc-upload-popup-wrapper">

    <!-- Main Form -->
    <div *ngIf="!isSubmitted">
        <h3 class="title mb-0">{{ 'QUOTATIONNEW_SUMMARY.SUBMIT_QUOTATION' | translate }}</h3>

        <div class="yellow-container">
            <!-- Selected Bookings -->
            <div class="my-input-group">
                <label>{{ 'QUOTATIONNEW_SUMMARY.BOOKINGS' | translate }} ({{ selectedQuotationItems?.length ||
                    0 }})</label>

                <div class="added-product-list">
                    <!-- Display Selected Quotation Items -->
                    <div class="added-product" *ngFor="let item of selectedQuotationItems; let i = index">
                        <img src="assets/images/new-set/product.png">
                        <span class="product-id booking-id">#{{ item.bookingNo }}</span>
                        <img src="assets/images/new-set/thin-cancel.svg" class="close-icon"
                            (click)="removeSelectedItem(item)" style="cursor: pointer;">
                    </div>
                </div>
            </div>

            <!-- Quotation Document -->
            <div class="my-input-group mt-2">
                <label>{{ 'QUOTATIONNEW_SUMMARY.QUOTATION_DOC' | translate }}</label>

                <div class="doc-files bg-transparent p-0 m-0">
                    <div class="file-attachment-container flex-one mt-0">
                        <div class="file-attached-container flex-one mt-0">
                            <div class="attachment file-attachment flex-one justify-content-between m-0">
                                <div class="d-flex align-items-center mr-2">
                                    <img [src]="getImageIcon(fileData)">
                                    <span class="file-name doc-name">{{ fileData?.fileName || 'No file selected'
                                        }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>



        <!-- Supporting Documents Upload -->
        <div class="my-input-group mt-3">
            <label>
                {{ 'QUOTATIONNEW_SUMMARY.SUPPORTING_DOC' | translate }}
                <div data-tooltip="You can upload supporting documents related to the quotation, such as proposals or reference files (optional)"
                    class="comment-badge rounded common-tooltip-table fix-width d-inline ml-0" 
                   >
                    <img src="assets/images/new-set/thick-info-gray.svg">
                </div>
            </label> 
            <!-- File Upload Area -->
            <div class="file-upload-container upload-files-container" (click)="supportingFileInput.click()"
                style="cursor: pointer;">
                <img src="assets/images/thin-gray-upload.svg" class="upload-icon">
                <div class="upload-here ml-2">
                    <p class="upload-content drop-file">
                      
                        <span>{{ 'QUOTATIONNEW_SUMMARY.BROWSE_FILE' | translate }}</span>
                    </p>
                </div>
            </div>
            <input #supportingFileInput type="file" multiple (change)="onSupportingDocumentSelected($event)"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png" hidden>

            <!-- Display Uploaded Supporting Documents -->
            <div class="file-attachment-container mt-2" *ngIf="supportingDocuments.length > 0">
                <div class="file-attached-container mt-2" *ngFor="let doc of supportingDocuments; let idx = index">
                    <div class="attachment flex-one justify-content-between m-0">
                        <div class="d-flex align-items-center mr-2">
                            <img [src]="getImageIcon(doc)">
                            <div class="d-flex flex-column">
                                <span class="file-name doc-name">{{ doc.fileName }}</span>
                                <span class="file-size text-muted small">{{ getFileSize(doc.fileSize) }}</span>
                            </div>
                        </div>
                        <img src="assets/images/new-set/close.svg" class="close-icon"
                            style="width: 16px; cursor: pointer;" (click)="removeSupportingDocument(idx)">
                    </div>
                </div>
            </div>
        </div>

        <!-- Description -->
        <div class="my-input-group mt-3">
            <label>{{ 'QUOTATIONNEW_SUMMARY.DESCRIPTION' | translate }}</label>
            <textarea placeholder="{{ 'QUOTATIONNEW_SUMMARY.ENTER_DESCRIPTION' | translate }}" [(ngModel)]="description"
                rows="4"></textarea>

        </div>

        <!-- Action Buttons -->

        <div class="column text-right cta-container">
            <button class="secondary-cta link cancel" [disabled]="isSubmitting"
                (click)="cancel()">{{'PRODUCT_DOCUMENT.BTN_CANCEL' |
                translate}}</button>
            <button class="primary-cta" [disabled]="isSubmitting" (click)="submitQuotation()">
                {{'QUOTATIONNEW_SUMMARY.SUBMIT' | translate}}
                <span *ngIf="isSubmitting">
                    <i class="fa fa-refresh fa-spin" aria-hidden="true"></i>
                </span>
            </button>
        </div>
    </div>

    <div class="popup-backdrop" *ngIf="isSubmitted"></div>

    <!-- Success Popup -->
<div class="popup-wrapper"
     *ngIf="isSubmitted"
     (click)="$event.stopPropagation()">
    <!-- Success Overlay -->
<!-- <div class="success-overlay d-flex align-items-center justify-content-center"
     *ngIf="isSubmitted"
     (click)="$event.stopPropagation()"> -->

    <!-- Success Message -->
    <div class="d-flex align-items-center justify-content-center" *ngIf="isSubmitted">
        <div class="submitted-container">
             <img  src="assets/images/new-set/thin-cancel.svg" alt="" class="cancel-icon" (click)="closeSuccessPopup()">
            <h3 class="title mb-0">{{ 'QUOTATIONNEW_SUMMARY.TITLE' | translate }}</h3>
            <img src="assets/success-animation.gif">
            <p class="submit-text">{{ 'QUOTATIONNEW_SUMMARY.SUCCESS_MESSAGE' | translate }}</p>
        </div>
    </div>
</div>